module.exports = __webpack_public_path__ + "static/img/tutto.13b02ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tutto.png
// module id = B2eI
// module chunks = 1